export class FinancialYearData {
    ID:number;
CLIENT_ID:number;
SR_NO:number;
NAME:string;
AMOUNT1:number;
AMOUNT2:number;
STATUS:boolean=true;

}